import React from "react";

import InputText, { PropsType as InputTextPropsType } from "commons/ui/input/InputText";

type PropsType = InputTextPropsType & {
    onChange?: (value: string) => void;
};

const blockInvalidChar = (e: any) => {
    return ["e", "E", "+", "-", ".", ","].includes(e.key) && e.preventDefault();
};

function IntegerInput({ onChange, ...props }: PropsType) {
    const checkOnChange = React.useCallback(
        (value: string) => {
            if (onChange) {
                onChange(value);
            }

            if (props.setValue && props.path) {
                props.setValue(props.path, value);
            }
        },
        [onChange, props]
    );

    const realOnChange = React.useCallback(
        (event: any) => {
            let newValue = "" + event.target.value;

            if (newValue !== "") {
                const numberRegex = /\d+$/g;

                if (numberRegex.test(newValue)) {
                    checkOnChange(newValue);
                }
            } else {
                checkOnChange(newValue);
            }
        },
        [checkOnChange]
    );

    return (
        <InputText
            {...props}
            type={"number"}
            min={0}
            onKeyDown={blockInvalidChar}
            onChange={realOnChange}
        />
    );
}

export default IntegerInput;
